import { ProductGroupReport, ReportsMessage } from '../../../types/SpecificReportMessage';

export const sortReportsByVolume = (a: ReportsMessage | ProductGroupReport, b: ReportsMessage | ProductGroupReport) => {
    return b.volume - a.volume;
};

export const sortReportsByName = (a: ReportsMessage, b: ReportsMessage) => {
    return a.context.name.localeCompare(b.context.name);
};
